import React from 'react';
import { Icon } from '../../../design-system/icons/Icon';
import { MENU_BUTTON_BASE, MENU_BUTTON_SIZE_DESKTOP, NAV_PART } from './nav-styles';

/**
 * Bars-only round menu button for the navbar live-index redesign (TEC navbar redesign Phase 1):
 * replaces the old UserMenu/DesktopFilterCategories menu button, which carried the avatar. The
 * avatar now lives in AccountPill instead, so this is only ever the hamburger icon.
 *
 * Base classes come from nav-styles.ts (TEC navbar redesign Phase 4 item 1) so the static twin
 * (ResourceNavbar.tsx) can render an identical pre-JS button before its own script replaces it.
 */
export const BarsMenuButton: React.FC<{
  onClick: () => void;
  ariaLabel: string;
  /** Tailwind size utility classes, e.g. "w-10 h-10" (40px, desktop row-one) or a responsive
   * "w-11 h-11 lg:w-10 lg:h-10" (44px on mobile tappables, 40px on the lg+ desktop row). */
  sizeClassName?: string;
}> = ({ onClick, ariaLabel, sizeClassName = MENU_BUTTON_SIZE_DESKTOP }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    data-jc-nav-part={NAV_PART.menuButton}
    className={`${MENU_BUTTON_BASE} ${sizeClassName}`}
  >
    <Icon name="bars3" useMaskForColor className="w-5 h-5" />
  </button>
);
